import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import AdoptedOnSide from './AdoptedOnSide';
import AdoptableSold from '../../../exclusives/presets/AdoptableSold';
export default withFeatureBranch({
    adoptables_resale: AdoptableSold
})(AdoptedOnSide);
